import { Icon } from "@/components/common/Icon";
import type { EnvironmentStatus } from "@/lib/api";

const HEADLINE: Partial<Record<EnvironmentStatus, string>> = {
	pending: "エージェントを起動しています…",
	waitingForCapacity: "インスタンスの確保を待っています…",
	shuttingDown: "エージェントを停止しています…",
};

/** 環境が起動していない間、ファイルツリーの代わりに表示するプレースホルダー。 */
export function EnvironmentStoppedPlaceholder({ status }: { status: EnvironmentStatus }) {
	return (
		<div
			data-testid="environment-files-stopped"
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				gap: 8,
				padding: "24px 12px",
				textAlign: "center",
				color: "var(--fg-3)",
				fontSize: "var(--text-caption)",
			}}
		>
			<Icon name="agent" size={24} />
			<p style={{ margin: 0, color: "var(--fg-2)" }}>
				{HEADLINE[status] ?? "エージェントが起動していません"}
			</p>
			<p style={{ margin: 0 }}>エージェントを起動するとファイルが表示されます。</p>
		</div>
	);
}
